import { TypographyStylesProvider } from "@mantine/core";

import { sanitizeForDisplay } from "../../lib/customerView/richHtml.js";

/**
 * Sanitisiertes Jira-HTML aus der API. Der Server hat mit sanitize-html
 * gefiltert; DOMPurify (in sanitizeForDisplay) ist der zweite Riegel vor dem
 * Einsetzen. Bilder zeigen auf /api/v1/customer-view/attachments/:id — das
 * Session-Cookie reicht, gleiche Origin.
 */
export function RichHtml({ html }: { html: string }) {
  return (
    <TypographyStylesProvider fz="sm">
      <div dangerouslySetInnerHTML={{ __html: sanitizeForDisplay(html) }} />
    </TypographyStylesProvider>
  );
}
